<span [style]="change >= 0 ? 'color: #42B747' : 'color: #B74242'">
  &lrm;{{ change >= 0 ? '+' : '' }}{{ change | amountShortener }}%
</span>
